import { Box, SxProps, Typography, styled } from '@mui/material';
import { memo, PropsWithChildren, ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface PredictionColumnCardProps extends PropsWithChildren {
  title: string;
  adornment?: ReactNode;
  sx?: SxProps;
}

export const PredictionColumnCardLayout = memo(function ({
  title,
  adornment,
  sx,
  children,
}: PredictionColumnCardProps): ReactElement {
  const { t } = useTranslation();
  return (
    <StyledBox sx={sx}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <div style={{ flex: 1 }} />
        <Typography flex={1} variant='h6' textAlign='center'>
          {t(title)}
        </Typography>
        <Box flex={1} display='flex' justifyContent='center' alignSelf='center'>
          {adornment}
        </Box>
      </Box>
      <ScrollableContent>{children}</ScrollableContent>
    </StyledBox>
  );
});

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%', // Re-enable height constraint
  overflow: 'hidden', // Prevent overflow at column level
  gap: '0.55rem',
  minWidth: 0,
  minHeight: 0, // Important for flex shrinking
});

const ScrollableContent = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  minHeight: 0,
  display: 'flex',
  justifyContent: 'center',
});
